import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import MarketingLayout from '../../components/MarketingLayout';
import { publicAdviserApi, type PublicAdviser } from '../../advisers/api';
import AdviserProfileView from '../../advisers/AdviserProfileView';

export default function AdviserProfilePage() {
  const { slug = '' } = useParams();
  const [profile, setProfile] = useState<PublicAdviser | null>(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let active = true;
    setLoading(true);
    setProfile(null);
    setError('');
    publicAdviserApi
      .profile(slug)
      .then((data) => {
        if (active) setProfile(data);
      })
      .catch((err) => {
        if (active) setError(err.message);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [slug]);
  useEffect(() => {
    if (!profile) return;
    document.title = `${profile.firmName} | Strategic Advisers | StratPlan`;
    const description = profile.headline || profile.introduction.slice(0, 160);
    [
      ['name', 'description'],
      ['property', 'og:description'],
      ['name', 'twitter:description'],
    ].forEach(([attribute, key]) => {
      document.querySelector(`meta[${attribute}="${key}"]`)?.setAttribute('content', description);
    });
    [
      ['property', 'og:title'],
      ['name', 'twitter:title'],
    ].forEach(([attribute, key]) => {
      document
        .querySelector(`meta[${attribute}="${key}"]`)
        ?.setAttribute('content', document.title);
    });
  }, [profile]);
  return (
    <MarketingLayout className="adviser-public">
      <div className="public-container adviser-profile-page">
        <Link to="/advisers" className="adviser-text-link">
          <ArrowLeft size={16} /> All advisers
        </Link>
        {loading ? (
          <p className="adviser-empty">Loading firm profile…</p>
        ) : error ? (
          <div className="adviser-empty">
            <h1>Profile unavailable</h1>
            <p role="alert">{error}</p>
            <Link to="/advisers">Explore other firms</Link>
          </div>
        ) : (
          profile && <AdviserProfileView profile={profile} />
        )}
      </div>
    </MarketingLayout>
  );
}
